import React, { useEffect, useState } from 'react'
import MaterialTable from 'material-table';
import { useAuth } from "../../context/auth";


const columns = [
  {
    'title' : 'Request ID',
    'field' : 'request_id'
  },
  {
    'title' : 'User ID',
    'field' : 'user_id'
  },
  {
    'title' : 'Request Type',
    'field' : 'request_type',
    'lookup': { 1:'Issue', 2:'Product', 3:'Feature' }
  },
  {
    'title' : 'Description',
    'field' : 'request_description'
  },
  {
    'title' : 'Created',
    'field' : 'created',
    customSort: (a,b) => {
      var date1 = new Date(a.created)
      var date2 = new Date(b.created)

      return date1 - date2
    },
  }
]

export default function Requests(){
  const [requests, setRequests] = useState([])
  const { auth } = useAuth();

  useEffect(() => {
    fetch('/api/report/request', {
      method: 'GET',
      headers: {
        'x-access-token': sessionStorage.getItem('token'),
      },
    })
    .then((response) => auth(response))
    .then((response) => {
      setRequests(response.data)
    })
    .catch((error) => {
      console.error('Error:', error)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  return (
    <MaterialTable
      title = 'Requests'
      columns = {columns}
      data = {requests}
      options={{
        filtering: true,
        draggable: false,
      }}
    />
  )
}
